import { render, staticRenderFns } from "./SignUpVerifyPhone.vue?vue&type=template&id=cc131b28&scoped=true"
import script from "./SignUpVerifyPhone.vue?vue&type=script&lang=js"
export * from "./SignUpVerifyPhone.vue?vue&type=script&lang=js"
import style0 from "./SignUpVerifyPhone.vue?vue&type=style&index=0&id=cc131b28&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc131b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc131b28')) {
      api.createRecord('cc131b28', component.options)
    } else {
      api.reload('cc131b28', component.options)
    }
    module.hot.accept("./SignUpVerifyPhone.vue?vue&type=template&id=cc131b28&scoped=true", function () {
      api.rerender('cc131b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sections/SignUpVerifyPhone.vue"
export default component.exports